import { Routes } from '@angular/router';
import {
    authenticatedGuard,
    unauthenticatedGuard,
} from 'fines-portal/auth/feature/auth';
import {
    RouteFragmentEnum,
    RouteParamEnum,
} from 'fines-portal/shared/router/data-access/router';
import { stepCanDeactivateGuard } from 'shared/design-system/feature/wizard';

export const finesPortalRoutes = [
    {
        path: '',
        redirectTo: RouteFragmentEnum.LOGIN,
        pathMatch: 'full',
    },
    {
        path: RouteFragmentEnum.LOGIN,
        children: [
            {
                path: '',
                canMatch: [unauthenticatedGuard],
                loadComponent: () =>
                    import('fines-portal/auth/feature/login').then(
                        (m) => m.LoginPageComponent,
                    ),
            },
            {
                path: RouteFragmentEnum.SUCCESS,
                redirectTo: `/${RouteFragmentEnum.LOGIN}`,
                pathMatch: 'full',
            },
            {
                path: RouteFragmentEnum.ERROR,
                loadComponent: () =>
                    import('fines-portal/auth/feature/login').then(
                        (m) => m.LoginErrorPageComponent,
                    ),
            },
        ],
    },
    {
        path: RouteFragmentEnum.LOGOUT,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('fines-portal/auth/feature/logout').then(
                        (m) => m.LogoutPageComponent,
                    ),
            },
            {
                path: RouteFragmentEnum.SUCCESS,
                redirectTo: `/${RouteFragmentEnum.LOGIN}`,
                pathMatch: 'full',
            },
            {
                path: RouteFragmentEnum.ERROR,
                redirectTo: `/${RouteFragmentEnum.LOGIN}`,
                pathMatch: 'full',
            },
        ],
    },
    {
        path: '',
        loadComponent: () =>
            import('fines-portal/core/ui/shell').then(
                (m) => m.FinesPortalShellComponent,
            ),
        canMatch: [authenticatedGuard],
        children: [
            {
                path: RouteFragmentEnum.FINES,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('fines-portal/core/feature/error').then(
                                (m) => m.NotFoundErrorPageComponent,
                            ),
                    },
                    {
                        path: RouteParamEnum.FINE_ID,
                        children: [
                            {
                                path: '',
                                loadComponent: () =>
                                    import(
                                        'fines-portal/fine/feature/detail'
                                    ).then((m) => m.FineDetailPageComponent),
                            },
                            {
                                path: RouteFragmentEnum.SELECTION,
                                loadComponent: () =>
                                    import(
                                        'fines-portal/fine/feature/driver-change'
                                    ).then((m) => m.FineSelectionPageComponent),
                            },
                            {
                                path: RouteFragmentEnum.DRIVER,
                                children: [
                                    {
                                        path: '',
                                        loadComponent: () =>
                                            import(
                                                'fines-portal/core/feature/error'
                                            ).then(
                                                (m) =>
                                                    m.NotFoundErrorPageComponent,
                                            ),
                                    },
                                    {
                                        path: RouteFragmentEnum.CREATE,
                                        loadComponent: () =>
                                            import(
                                                'fines-portal/fine/feature/driver-change'
                                            ).then(
                                                (m) =>
                                                    m.DriverWizardPageComponent,
                                            ),
                                        canDeactivate: [stepCanDeactivateGuard],
                                        children: [
                                            {
                                                path: '',
                                                redirectTo:
                                                    RouteFragmentEnum.DRIVER_CHANGE_DRIVER,
                                                pathMatch: 'full',
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_DRIVER,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeDriverStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_NATIONALITY,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeNationalityStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_DRIVER_DETAILS,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeDriverDetailsStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_DETAILS,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeDetailsStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_FILES,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeFilesStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_PRIVACY,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangePrivacyStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.DRIVER_CHANGE_SUMMARY,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/driver-change'
                                                    ).then(
                                                        (m) =>
                                                            m.DriverChangeSummaryStepComponent,
                                                    ),
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: RouteFragmentEnum.OBJECTION,
                                children: [
                                    {
                                        path: '',
                                        loadComponent: () =>
                                            import(
                                                'fines-portal/core/feature/error'
                                            ).then(
                                                (m) =>
                                                    m.NotFoundErrorPageComponent,
                                            ),
                                    },
                                    {
                                        path: RouteFragmentEnum.CREATE,
                                        loadComponent: () =>
                                            import(
                                                'fines-portal/fine/feature/objection'
                                            ).then(
                                                (m) =>
                                                    m.ObjectionWizardPageComponent,
                                            ),
                                        canDeactivate: [stepCanDeactivateGuard],
                                        children: [
                                            {
                                                path: '',
                                                redirectTo:
                                                    RouteFragmentEnum.OTHER_DRIVER_ARGUMENTATION,
                                                pathMatch: 'full',
                                            },
                                            {
                                                path: RouteFragmentEnum.OTHER_DRIVER_DETAILS,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/objection'
                                                    ).then(
                                                        (m) =>
                                                            m.ObjectionDetailsStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.OTHER_DRIVER_ARGUMENTATION,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/objection'
                                                    ).then(
                                                        (m) =>
                                                            m.ObjectionArgumentationStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.OTHER_DRIVER_ARGUMENTATION_FILES,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/objection'
                                                    ).then(
                                                        (m) =>
                                                            m.ObjectionFilesStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.OTHER_DRIVER_PRIVACY,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/objection'
                                                    ).then(
                                                        (m) =>
                                                            m.ObjectionPrivacyStepComponent,
                                                    ),
                                            },
                                            {
                                                path: RouteFragmentEnum.OTHER_DRIVER_SUMMARY,
                                                loadComponent: () =>
                                                    import(
                                                        'fines-portal/fine/feature/objection'
                                                    ).then(
                                                        (m) =>
                                                            m.ObjectionSummaryStepComponent,
                                                    ),
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        path: '**',
        loadComponent: () =>
            import('fines-portal/core/feature/error').then(
                (m) => m.NotFoundErrorPageComponent,
            ),
    },
] satisfies Routes;
